module.exports = __webpack_public_path__ + "static/media/new-img2.86191f3c.png";